// client/src/components/fidelidade/PremioForm.js
import React, { useState } from 'react';
import { Save, XCircle } from 'lucide-react';

const FORM_VAZIO = { nome: '', descricao: '', custoPontos: '', imagem: '', quantidadeDisponivel: '' };

const PremioForm = ({ premio, onSalvar, onCancelar, isPending }) => {
    const [form, setForm] = useState(() => premio ? {
        nome: premio.nome || '',
        descricao: premio.descricao || '',
        custoPontos: premio.custoPontos ?? '',
        imagem: premio.imagem || '',
        quantidadeDisponivel: premio.quantidadeDisponivel ?? '',
    } : FORM_VAZIO);

    const isEditing = !!premio;

    const handleSubmit = (e) => {
        e.preventDefault();
        onSalvar({
            nome: form.nome.trim(),
            descricao: form.descricao.trim() || undefined,
            custoPontos: Number(form.custoPontos) || 0,
            imagem: form.imagem.trim() || undefined,
            quantidadeDisponivel: form.quantidadeDisponivel === '' ? null : Number(form.quantidadeDisponivel),
        });
    };

    return (
        <div className="content-panel">
            <form onSubmit={handleSubmit}>
                <div className="form-section">
                    <h4 className="form-section-title">{isEditing ? `Editar Prêmio: ${premio.nome}` : 'Novo Prêmio'}</h4>
                    <div className="form-grid-container-cols-2">
                        <div className="form-group">
                            <label className="form-label required">Nome do Prêmio</label>
                            <input
                                type="text"
                                className="form-input"
                                value={form.nome}
                                onChange={(e) => setForm((p) => ({ ...p, nome: e.target.value }))}
                                placeholder="Ex: Limpeza de Pele Grátis"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label required">Custo em Pontos</label>
                            <input
                                type="number"
                                min="1"
                                className="form-input"
                                value={form.custoPontos}
                                onChange={(e) => setForm((p) => ({ ...p, custoPontos: e.target.value }))}
                                required
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <label className="form-label">Descrição</label>
                        <textarea
                            className="form-input"
                            rows={2}
                            value={form.descricao}
                            onChange={(e) => setForm((p) => ({ ...p, descricao: e.target.value }))}
                            placeholder="Detalhes do que o cliente recebe ao trocar os pontos"
                        />
                    </div>
                    <div className="form-grid-container-cols-2">
                        <div className="form-group">
                            <label className="form-label">URL da Imagem</label>
                            <input
                                type="text"
                                className="form-input"
                                value={form.imagem}
                                onChange={(e) => setForm((p) => ({ ...p, imagem: e.target.value }))}
                                placeholder="https://..."
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Quantidade Disponível</label>
                            <input
                                type="number"
                                min="0"
                                className="form-input"
                                value={form.quantidadeDisponivel}
                                onChange={(e) => setForm((p) => ({ ...p, quantidadeDisponivel: e.target.value }))}
                                placeholder="Deixe em branco para ilimitado"
                            />
                        </div>
                    </div>
                </div>

                <div className="form-actions">
                    <button type="button" onClick={onCancelar} className="action-button action-button-secondary">
                        <XCircle size={18} className="icon" /> Cancelar
                    </button>
                    <button type="submit" className="action-button action-button-primary" disabled={isPending}>
                        <Save size={18} className="icon" /> {isPending ? 'Salvando...' : isEditing ? 'Salvar Alterações' : 'Criar Prêmio'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default PremioForm;
